import { Injectable } from '@angular/core'
import { FormArray, FormControl, FormGroup } from '@angular/forms'

import { Observable, filter, map } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbFormService {
  syncFormWithState<T>(form: FormGroup, state$: Observable<T | undefined | null>): Observable<void> {
    return state$.pipe(
      filter((state) => !!state),
      map((state) => {
        this.patchValues(state as T, form)
      }),
    )
  }

  patchValues<T>(entity: T, form: FormGroup): void {
    Object.keys(form.controls).forEach((key) => {
      const control = form.controls[key]
      const value = (entity as T)[key as keyof T]

      if (control instanceof FormArray) {
        control.clear()
        if (Array.isArray(value)) {
          value.forEach((v) => {
            if (v !== null && typeof v === 'object' && !Array.isArray(v)) {
              const groupControls: Record<string, FormControl> = {}
              Object.keys(v as Record<string, unknown>).forEach((groupKey) => {
                groupControls[groupKey] = new FormControl((v as Record<string, unknown>)[groupKey])
              })
              control.push(new FormGroup(groupControls))
            } else {
              control.push(new FormControl(v))
            }
          })
        }
      } else if (control instanceof FormGroup && this.hasFormArray(control, value)) {
        // recurse into the FormGroup to patch any nested FormArray controls
        this.patchValues(value, control)
      } else {
        const patchObject: Record<string, unknown> = {}
        patchObject[key] = value
        form.patchValue(patchObject)
      }
    })
  }

  private hasFormArray<T>(formGroup: FormGroup, value: T | null | undefined): boolean {
    if (!value) return false
    return Object.values(formGroup.controls).some((c) => c instanceof FormArray)
  }
}
